import { api } from './api';

// Get standardized States (e.g. Karnataka, Maharashtra)
export const getAllStates = () => api.get('/admin/ref/states');

// Get standardized Cities for a State
export const getCitiesByState = (stateCode: string) => api.get(`/admin/ref/cities/${stateCode}`);